const cache = new WeakMap();

export default (study, extraData) => {
  const displaySets = extraData?.displaySets;
  if (!displaySets) return [];
  if (cache.has(displaySets)) return cache.get(displaySets);
  
  const result = displaySets.map(ds => ds.SeriesDescription);
  cache.set(displaySets, result);
  return result;
};
